import { IKImage } from 'imagekitio-react';
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { motion } from "framer-motion";
import { useTheme } from '../contexts/ThemeContext';

const Card = ({item, index}) => {
    const location = useLocation();
    const navigate = useNavigate()
    const { isDark } = useTheme();

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            viewport={{ once: true }}
            whileHover={{ y: -8 }}
            key={index}
            className="w-full lg:w-[31%] min-w-[280px] max-w-[400px]"
        >
            <div className={`rounded-lg overflow-hidden border transition-all ${
                isDark
                    ? 'bg-dark-bg-card border-dark-border hover:border-dark-brand-primary hover:shadow-glow-sm'
                    : 'bg-light-bg-card border-light-border hover:border-light-brand-primary hover:shadow-light-glow-sm shadow-sm'
            }`}>
                {/* Terminal-style header */}
                <div className={`px-4 py-2 border-b font-mono text-xs flex items-center gap-2 ${
                    isDark
                        ? 'bg-dark-bg-tertiary border-dark-border'
                        : 'bg-light-bg-tertiary border-light-border'
                }`}>
                    {/* Window dots */}
                    <div className="flex gap-1.5">
                        <div className={`w-2.5 h-2.5 rounded-full ${
                            isDark ? 'bg-red-500' : 'bg-red-400'
                        }`}></div>
                        <div className={`w-2.5 h-2.5 rounded-full ${
                            isDark ? 'bg-yellow-500' : 'bg-yellow-400'
                        }`}></div>
                        <div className={`w-2.5 h-2.5 rounded-full ${
                            isDark ? 'bg-green-500' : 'bg-green-400'
                        }`}></div>
                    </div>
                    <span className={isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}>
                        {item.name?.substring(0, 20)}...
                    </span>
                </div>

                {/* Image */}
                <Link to={location.pathname==="/"? `projects/${item.id}` : `${item.id}`}>
                    <button onClick={() => window.scrollTo(0,0)} className="w-full">
                        <div className="relative overflow-hidden aspect-video group">
                            <IKImage
                                path={item.image[0]}
                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            />
                            {/* Overlay on hover */}
                            <div className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center ${
                                isDark ? 'bg-dark-bg-primary/80' : 'bg-light-bg-primary/80'
                            }`}>
                                <span className={`font-mono text-sm ${
                                    isDark ? 'text-dark-brand-primary' : 'text-light-brand-primary'
                                }`}>
                                    $ open_project
                                </span>
                            </div>
                        </div>
                    </button>
                </Link>

                {/* Content */}
                <div className='p-4'>
                    <Link to={location.pathname==="/"? `projects/${item.id}` : `${item.id}`}>
                        <button
                            onClick={() => window.scrollTo(0,0)}
                            className={`font-mono font-semibold text-lg mb-3 text-left hover:underline transition-colors ${
                                isDark
                                    ? 'text-dark-text-primary hover:text-dark-brand-primary'
                                    : 'text-light-text-primary hover:text-light-brand-primary'
                            }`}
                        >
                            {item.name}
                        </button>
                    </Link>

                    {/* Category tags */}
                    <div className="flex flex-wrap gap-2">
                        {item.category.map((category, idx) =>
                            <motion.button
                                key={idx}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => {
                                    navigate("/projects", { state: { tab: category } })
                                }}
                                className={`text-xs font-mono px-2 py-1 rounded border transition-all ${
                                    isDark
                                        ? 'text-dark-brand-secondary border-dark-border bg-dark-bg-tertiary hover:border-dark-brand-secondary'
                                        : 'text-light-brand-secondary border-light-border bg-light-bg-tertiary hover:border-light-brand-secondary'
                                }`}
                            >
                                #{category}
                            </motion.button>
                        )}
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default Card
